{
  "version": 1,
  "asset_id": "727021ca-0243-483f-87ca-bcc905656a29",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/727021ca-0243-483f-87ca-bcc905656a29/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/727021ca-0243-483f-87ca-bcc905656a29/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.webp",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.webp",
  "size": 33986,
  "content_type": "image/webp",
  "created_at": "2026-08-27T15:21:12Z"
}
